if (!customElements.get('collection-lightbox')) {
  customElements.define(
    'collection-lightbox',
    class CollectionLightbox extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.slides = Array.from(this.querySelectorAll('.collection-lightbox__slide'));
        this.triggers = Array.from(document.querySelectorAll(`[data-lightbox-for="${this.id}"]`));
        this.activeIndex = 0;
        this.openedBy = null;

        this.triggers.forEach((trigger, index) => {
          trigger.addEventListener('click', () => this.openAt(index, trigger));
        });

        this.querySelector('.collection-lightbox__close')?.addEventListener('click', () => this.close());
        this.querySelector('.collection-lightbox__prev')?.addEventListener('click', () => this.step(-1));
        this.querySelector('.collection-lightbox__next')?.addEventListener('click', () => this.step(1));

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });

        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.step(-1);
          if (event.key === 'ArrowRight') this.step(1);
        });

        // Native <dialog> fires 'close' for both close() calls and the Escape key.
        this.dialog.addEventListener('close', () => this.onClosed());
      }

      openAt(index, trigger) {
        this.activeIndex = index;
        this.openedBy = trigger || null;
        this.showSlide(index);

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        if (typeof window.trapFocus === 'function') {
          window.trapFocus(this.dialog);
        }
      }

      step(delta) {
        if (this.slides.length < 2) return;
        const next = (this.activeIndex + delta + this.slides.length) % this.slides.length;
        this.activeIndex = next;
        this.showSlide(next);
      }

      showSlide(index) {
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== index;
        });
      }

      close() {
        if (typeof this.dialog.close === 'function' && this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.onClosed();
        }
      }

      onClosed() {
        if (typeof window.removeTrapFocus === 'function') {
          window.removeTrapFocus(this.openedBy);
        } else if (this.openedBy) {
          this.openedBy.focus();
        }
      }
    }
  );
}
